// extracted by mini-css-extract-plugin
module.exports = {"main":"ReviewGuide-module__main___23j7E","title":"ReviewGuide-module__title___3gNpT","large":"ReviewGuide-module__large___3D4AI","assets":"ReviewGuide-module__assets___2-HcG"};